import { render, staticRenderFns } from "./Filial.vue?vue&type=template&id=50c8a9de"
import script from "./Filial.vue?vue&type=script&lang=js"
export * from "./Filial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports